module.exports = __webpack_public_path__ + "img/aprovisiona.f1a14d37.png";